import { Theme } from '@mui/material';
import { TooltipParams } from 'components/chart/tooltip';
import { map } from 'lodash';
import { makeAutoObservable } from 'mobx';
import { Dictionary } from 'mobx/helpers/dictionary';

type StatItem = {
  count: number;
  death_count: number;
  injured_count: number;
  month_year: string;
};

export type DtpCategoryStatItemData = {
  category_id: string;
  stats: StatItem[];
};

export class DtpCategoryStatItem {
  private _data: DtpCategoryStatItemData;
  private _categories: Dictionary;

  constructor(data: DtpCategoryStatItemData, categories: Dictionary) {
    this._data = data;
    this._categories = categories;
    makeAutoObservable(this);
  }

  public getColor(theme: Theme) {
    return (
      theme.palette.custom.dtpTypes[this._data.category_id] ||
      theme.palette.custom.dtpTypes.other
    );
  }

  public get categoryId() {
    return this._data.category_id;
  }

  public get lastMonthCount() {
    return this._data.stats.at(-1)?.count || 0;
  }

  public asLineChartItem(theme: Theme): Highcharts.SeriesLineOptions {
    const seriesName =
      this._categories.find(this._data.category_id)?.name || '';
    return {
      type: 'line',
      name: seriesName,
      color: this.getColor(theme),
      data: map(this._data.stats, (stat) => {
        return {
          y: stat.count,
          name: stat.month_year,
          color: this.getColor(theme),
          marker: { symbol: 'circle' },
          custom: {
            value: stat.count,
            seriesName,
            xName: String(stat.month_year),
            color: this.getColor(theme),
            injured_count: stat.injured_count,
            death_count: stat.death_count,
          } as TooltipParams,
        };
      }),
    };
  }
}
